import {animate, state, style, transition, trigger} from '@angular/animations';

export const FadeOut =
    trigger('fadeOut', [
        state('out',
            style({
                opacity: 0
            })
        ),
        transition('* => void', [
            style({
                opacity: 1
            }),
            animate('0.25s ease-in')
        ])
    ]);
